// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","logoText":"Navbar_logoText__P+5Sb","githubLogo":"Navbar_githubLogo__Bwbcu"};